import React, { useEffect, useRef, useState } from "react";
// import "croppie/croppie.css";
import { deepClone, toCamelCase } from "../../../helpers/objectHelper";
import SystemLabel from "../../../system/SystemLabel/SystemLabel";
import CropTwoToneIcon from "@material-ui/icons/CropTwoTone";
import { observer } from "mobx-react-lite";
import { usePrevious } from "../../helpers/usePrevious";
import Axios from "axios";
// import { ImageCropper } from "../../components/ImageCropper";
import FolderIcon from "@material-ui/icons/Folder";
import { ProfileUploadCrop } from "./components/ProfileUploadCrop";
export const ProfileImageUploader = observer((props) => {
  const [source, setSource] = useState("");
  const [isCropping, setIsCropping] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);

  const prevProps = usePrevious(props);
  const imgRef = useRef();

  const { activePersonNo, orders, settings, environment, updateOrder, contentLayoutModuleId } = props;
  const { size, shape, viewport, defaultImage, hidden } = settings;

  useEffect(() => {
    loadImage();
  }, []);
  useEffect(() => {
    if (defaultImage && prevProps && prevProps.settings.defaultImage != settings.defaultImage) {
      setSource(defaultImage);
    }
    if (prevProps && activePersonNo != prevProps.activePersonNo) {
      loadImage();
    }
  });
  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  const loadImage = () => {
    const { defaultImage } = settings;
    if (orders) {
      let order = orders[activePersonNo];

      let newOrder = deepClone(order);
      let type = newOrder[toCamelCase("ProfileImage")];

      let newType = undefined;
      if (!type) {
        newType = { source: "" };
      } else {
        newType = deepClone(type);
      }

      if (newType.file) {
        return setSource(newType.file);
      }

      if (newType[toCamelCase("Source")]) {
        setSource(newType[toCamelCase("Source")]);
      } else {
        newType[toCamelCase("File")] = defaultImage || null;
        setSource(defaultImage || "https://www.xovi.com/wp-content/plugins/all-in-one-seo-pack/images/default-user-image.png");
      }
      newOrder[toCamelCase("ProfileImage")] = newType;
      updateOrder(newOrder);
    } else {
      setSource(defaultImage || "https://www.xovi.com/wp-content/plugins/all-in-one-seo-pack/images/default-user-image.png");
    }
  };
  const onImageUpload = async (e) => {
    const file = e.target.files[0];

    const result = await toBase64(file).catch((e) => Error(e));
    if (result instanceof Error) {
      console.error("Error: ", result.message);
      return;
    }
    
    setSource(result);
    setIsCropping(true);

    //You can not post when prop
  };
  const setImageOnOrder = (source) => {
    if (orders) {
      let order = orders[activePersonNo];

      let newOrder = deepClone(order);
      let type = newOrder[toCamelCase("ProfileImage")];
      let newType = undefined;

      if (!type) {
        newType = { source: "" };
      } else {
        newType = deepClone(type);
      }

      Axios.post(`./api/files/profileimagetemp/${environment.eventId}`, {
        file: source,
        name: `${order.sqlStateNo + "_" + activePersonNo}_ProfileImage.png`,
        type: "image/png",
      }).then(({ data }) => {
        newType.file = data;
        newOrder[toCamelCase("ProfileImage")] = newType;
        updateOrder(newOrder);
      });
    }
  };
  const onCropped = (source) => {
    setImageOnOrder(source);
    setSource(source);
    setIsCropping(false);
  };
  const setImageClassName = (type) => {
    switch (type) {
      case "SQUARE":
        return "square--landscape";
      case "CIRCULAR":
        return "circular--landscape";
      default:
        return "";
    }
  };
  const fuRef = useRef();
  const handleImageLoaded = () => setImageLoaded(true);
  if (hidden) return null;
  return (
    <div className="profile-upload-wrap">
      <div className={`image-container ${setImageClassName(shape)}`}>
        <div
          style={{
            width: viewport.width + "px",
            height: viewport.height + "px",
          }}
        >
          {isCropping ? (
            <ProfileUploadCrop src={source} shape={shape} onCropped={onCropped} onCancel={() =>  setIsCropping(false)} aspectRatio={`${viewport.width}/${viewport.height}`} />
          ) : (
            <img
              ref={imgRef}
              onLoad={handleImageLoaded}
              src={source + (source && source.toString()?.startsWith("http") ? `?rnd=${+new Date()}` : "")}
              className={`${imageLoaded ? "unblur" : "blur"}`}
              alt="image"
            />
          )}
        </div>
      </div>
      <div
        className="profile-upload-btn-wrap"
        style={{
          // margin: "10px auto",
          marginBottom: isCropping ? "25px" : 0,
        }}
      >
        {/* {isCropping ? <ImageCropper parentId={contentLayoutModuleId} source={source} shape={shape} size={size} viewport={viewport} onCropped={onCropped} backgroundColor={"#fff"} /> : null} */}

        {!isCropping ? (
          <button className="cms-button profile-upload-button" onClick={(e) => fuRef.current.click()}>
            <FolderIcon />
            <SystemLabel name="Upload" />
          </button>
        ) : null}
        {!isCropping ? (
          <button className="cms-button profile-crop-button" style={{ marginLeft: 5 }} onClick={() => setIsCropping(true)}>
            <CropTwoToneIcon />
            <SystemLabel name="Crop" />
          </button>
        ) : null}
      </div>
      <input ref={fuRef} id="file-upload-pfi" className="profile-file-upload" type="file" accept="image/*" onChange={(e) => onImageUpload(e)} />
    </div>
  );
});
